import { isValidContactDisplay } from './Contact';
const defaultContactDisplay = {
  id: 'n.a.',
  name: 'n.a.'
};
export const contactDisplayApiToContactDisplay = contactDisplay => {
  if (!contactDisplay) {
    throw new Error('undefined contactDisplayApi', {
      cause: {
        contactDisplay
      }
    });
  }
  const contactDisplayWithDefaults = {
    ...defaultContactDisplay,
    ...contactDisplay
  };
  if (isValidContactDisplay(contactDisplayWithDefaults)) {
    return contactDisplayWithDefaults;
  }
  throw new Error('Invalid contactDisplayApi', {
    cause: {
      contactDisplay
    }
  });
};
//# sourceMappingURL=converters.js.map